import React from 'react';

import { EmptyStateOverlay } from '@trqk/components';
import { locale } from '@trqk/utils';

import emptyStatementImg from '../../assets/svg/statements_empty.svg';

export const ShouldSelectStatements = (): JSX.Element => (
    <EmptyStateOverlay>
        <div className="px-16 pt-12">
            <img
                src={emptyStatementImg}
                width={35}
                alt="Empty statement icon"
            />
            <div className="text-xs font-semibold tracking-widest mt-6 mb-4">
                {locale.enUS.STATEMENTS.SHOULD_SELECT_STATEMENTS.TITLE.toUpperCase()}
            </div>
            <div className="text-xl font-semibold">
                {
                    locale.enUS.STATEMENTS.SHOULD_SELECT_STATEMENTS
                        .SELECT_A_STATEMENT
                }
            </div>
        </div>
    </EmptyStateOverlay>
);
